import { all } from 'redux-saga/effects';

import { fetchWorkordersSaga } from './fetchWorkorder';

export function* saga() {
    yield all([fetchWorkordersSaga()]);
}
